import { Component, OnInit, ViewChild } from "@angular/core";

import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";

import { ConfirmDeletionComponent } from "@shared/components/confirm-deletion/confirm-deletion.component";
import { SwalService } from "@shared/utils/swal.service";
import { DefinicionesFormComponent } from "./definiciones-form/definiciones-form.component";
import { ProDefinicionesService } from "@p-p-portafolio/services/pro-definiciones.service";
import { ProDefiniciones } from "@shared/interfaces/request/proDefiniciones";
import { SharedDataService } from "@shared/utils/shared-data.service";

@Component({
  selector: 'app-definiciones',
  templateUrl: './definiciones.component.html',
  styleUrls: ['./definiciones.component.css']
})
export class DefinicionesComponent implements OnInit {
  public promocion: string;
  public columns = [
    { field: 'numVar', header: 'Variable' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'formula', header: 'Fórmula' },
    { field: 'actions', header: 'Acciones' }
  ];
  private readonly _width: string = '900px';
  public allData: number = 0;

  public dataSource: any = [];
  public loading: boolean = true;

  constructor(
    public _dialog: MatDialog,
    private _swalService: SwalService,
    private _proDefServices: ProDefinicionesService,
    private route: ActivatedRoute,
    private router: Router,
    private sharedDataService: SharedDataService
  ) {}

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    this.promocion = String(routeParams.get('promocion'));

    this.read();
  }

  goBack() {
    window.history.back();
  }

  read() {
    this._proDefServices.read(this.promocion).subscribe((res) => {
      this.dataSource = res.data;
      if (res.data) this.allData = res.data.length;
      if (this.allData >= 0) this.loading = false;
    });
  }

  openCreate() {
    localStorage.setItem('prom', this.promocion);
    const dialogRef = this._dialog.open(DefinicionesFormComponent, {
      width: this._width
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read();
    });
  }

  openUpdate(model: ProDefiniciones) {
    console.log(model);
    const dialogRef = this._dialog.open(DefinicionesFormComponent, {
      width: this._width,
      data: model
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read();
    });
  }

  openDefGeneral() {
    console.log(this.dataSource);
    const model: any = this.dataSource[0];
    this.sharedDataService.updateData(model);
    this.router.navigate(['CredisystemSite/portafolio/promociones/funciones/definiciones/definicion-general/' + this.promocion]);
  }

  openDefMoratorios() {
    const model: any = this.dataSource[1];
    this.sharedDataService.updateData(model);
    this.router.navigate(['CredisystemSite/portafolio/promociones/funciones/definiciones/definicion-moratorios/' + this.promocion]);
  }

  deleteM(rowData) {
    const dialogRef = this._dialog.open(ConfirmDeletionComponent, {
      width: '310px'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._proDefServices.delete(rowData).subscribe((res) => {
          if (res.exito === 1) this._swalService.success('Eliminado');
          else this._swalService.error('No Eliminado');
          this.read();
        });
      }
    });
  }
}
